import React, { useEffect, useState } from "react";
import { Dimensions, Platform, ScrollView, StyleSheet, TouchableOpacity, View } from "react-native";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StepperTypeTokens, SupportingDocumentContext, UploadFileStatus } from "@voltmoney/schema";
import { SCREEN_SIZE } from '@voltmoney/types';
import { Header } from "../../header/Header";
import { Button } from "../../button/Button";
import { Icon } from "../../icon/Icon";
import { Typography } from "../../typography/Typography";
import { Space } from "../../space/Space";
import { DropdownInput } from "../../dropDownInput/DropDownBaseInput";
import { generateAccordianDataSupportDocument } from "./utils";
import { UploadFile } from "../../UploadFile/UploadFile";
const SupportingDocumentPage = ({ height, stepperData, supportDocumentType, context, onSelectDocument, uploadFile, triggerAction, accountNumber, goBackAction, goBackHeaderAction, headerTitle, loading = false, }) => {
    const [_context, setContext] = useState(context);
    const [_supportDocumentType, setSupportDocumentType] = useState(supportDocumentType);
    const [_accordianData, setAccordianData] = useState(generateAccordianDataSupportDocument(supportDocumentType?.supportingDocumentAllowed?.documentDetails));
    const [_document, setDocument] = useState(undefined);
    const [_frontFile, setFrontFile] = useState(undefined);
    const [_backFile, setBackFile] = useState(undefined);
    const [_frontKey, setFrontKey] = useState(1);
    const [_backKey, setBackKey] = useState(1);
    const [_isBtnActive, setBtnActive] = useState(false);
    const stepperProps = {
        data: stepperData,
        type: StepperTypeTokens.HORIZONTAL,
        onPress: null,
    };
    const handleAccordianValue = (value) => {
        setDocument(value);
    };
    const handleGoBack = () => {
        goBackAction &&
            triggerAction(goBackAction);
    };
    const handleHeaderGoBack = () => {
        goBackHeaderAction &&
            triggerAction(goBackHeaderAction);
    };
    const handleSubmitForApproval = () => {
        uploadFile &&
            triggerAction({
                ...uploadFile,
                payload: {
                    frontValue: _frontFile,
                    backValue: _backFile,
                    documentType: _document,
                    ...uploadFile.payload
                }
            });
    };
    //this will run each time a user changes or selects document type
    useEffect(() => {
        if (_document) {
            onSelectDocument &&
                triggerAction({
                    ...onSelectDocument,
                    payload: {
                        documentType: _document,
                        ...onSelectDocument.payload,
                    }
                });
        }
        setFrontKey(prev => prev + 1);
        setBackKey(prev => prev + 1);
        setBtnActive(false);
        setFrontFile(undefined);
        setBackFile(undefined);
    }, [_document]);
    //this will run each time a user changes or selects document type
    useEffect(() => {
        if (_document
            && _supportDocumentType
            && _supportDocumentType?.supportingDocumentAllowed?.documentDetails[`${_document}`].isBackSideRequired) {
            if (_frontFile && _backFile) {
                setBtnActive(true);
            }
            else {
                setBtnActive(false);
            }
        }
        else {
            if (_frontFile) {
                setBtnActive(true);
            }
            else {
                setBtnActive(false);
            }
        }
    }, [_frontFile, _backFile]);
    const _headerChild = () => {
        return (React.createElement(View, { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between'
            } },
            React.createElement(Header, { type: HeaderTypeTokens.verification, stepperProps: stepperProps, isBackButton: true, title: headerTitle ? headerTitle : 'title', onPress: () => {
                    handleHeaderGoBack();
                } })));
    };
    const _bodyChild = () => {
        return (React.createElement(React.Fragment, null, React.createElement(ScrollView, { style: styles.bodyContainer },
            React.createElement(View, null,
                React.createElement(View, { style: styles.bodyTopContainer },
                    React.createElement(TouchableOpacity, { style: styles.backContainer, onPress: () => handleGoBack() },
                        React.createElement(View, { style: styles.backIconContainer },
                            React.createElement(Icon, { name: IconTokens.ChevronLeft, size: IconSizeTokens.MD })),
                        React.createElement(Typography, { label: 'Go back', fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, fontWeight: '700', lineHeight: 20 }))),
                React.createElement(Space, { size: SizeTypeTokens.XL }),
                React.createElement(Typography, { label: context === SupportingDocumentContext.KYC_MISMATCH
                        ? 'Provide additional document for KYC verification'
                        : context === SupportingDocumentContext.BANK_MISMATCH
                            ? 'Provide additional document to verify  your bank account'
                            : context === SupportingDocumentContext.PHOTO_MISMATCH
                                ? 'Provide additional document for photo verification'
                                : '', fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Poppins, fontWeight: '600', lineHeight: 24 }),
                React.createElement(Space, { size: SizeTypeTokens.XL }),
                context === SupportingDocumentContext.PHOTO_MISMATCH && (React.createElement(View, { style: styles.subtitleContainer },
                    React.createElement(Typography, { label: 'We\'ll match the captured photo with the photo on your document. Upload a document that displays a clear and recent photo.', fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', lineHeight: 18 }))),
                context === SupportingDocumentContext.KYC_MISMATCH && (React.createElement(View, { style: styles.subtitleContainer },
                    React.createElement(Typography, { label: 'We will match the name on the document with the name as per the PAN', fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', lineHeight: 18 }))),
                context === SupportingDocumentContext.BANK_MISMATCH && (React.createElement(React.Fragment, null,
                    React.createElement(Typography, { label: accountNumber ? `For bank account: XXXX ${accountNumber?.slice(-4)}` : '', fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, fontWeight: '500', lineHeight: 20 }))),
                React.createElement(Space, { size: SizeTypeTokens.XL }),
                React.createElement(DropdownInput, { label: context === SupportingDocumentContext.KYC_MISMATCH
                        ? 'Select ID proof to upload'
                        : context === SupportingDocumentContext.BANK_MISMATCH
                            ? 'Select document type'
                            : context === SupportingDocumentContext.PHOTO_MISMATCH
                                ? 'Select ID proof for upload'
                                : '', data: _accordianData, height: context === SupportingDocumentContext.BANK_MISMATCH ? 135 : 180, onValueSelect: (value) => handleAccordianValue(value) }),
                React.createElement(Space, { size: SizeTypeTokens.XXXL }),
                _document &&
                    React.createElement(React.Fragment, null,
                        React.createElement(View, null,
                            React.createElement(Typography, { label: 'Upload document', fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Poppins, fontWeight: '600', lineHeight: 24 }),
                            React.createElement(Space, { size: SizeTypeTokens.XXXL }),
                            React.createElement(Typography, { label: 'Front side', fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Inter, fontWeight: '600', lineHeight: 24 }),
                            React.createElement(Space, { size: SizeTypeTokens.MD }),
                            React.createElement(View, { key: _frontKey },
                                React.createElement(UploadFile, { status: UploadFileStatus.DEFAULT, setUploadFile: setFrontFile, onDeleteFile: () => { setFrontFile(undefined); }, errorMessage: 'Supported file format of max. size 2 MB - jpeg, pdf, png', message: 'Supported file format of max. size 2 MB - jpeg, pdf, png', loading: loading })),
                            React.createElement(Space, { size: SizeTypeTokens.XL }),
                            _document &&
                                _supportDocumentType &&
                                _supportDocumentType?.supportingDocumentAllowed?.documentDetails[`${_document}`].isBackSideRequired &&
                                React.createElement(React.Fragment, null,
                                    React.createElement(Typography, { label: 'Back side', fontSize: FontSizeTokens.MD, fontFamily: FontFamilyTokens.Inter, fontWeight: '600', lineHeight: 24 }),
                                    React.createElement(Space, { size: SizeTypeTokens.MD }),
                                    React.createElement(View, { key: _backKey },
                                        React.createElement(UploadFile, { status: UploadFileStatus.DEFAULT, setUploadFile: setBackFile, onDeleteFile: () => { setBackFile(undefined); }, errorMessage: 'Supported file format of max. size 2 MB - jpeg, pdf, png', message: 'Supported file format of max. size 2 MB - jpeg, pdf, png', loading: loading }))))),
                React.createElement(Space, { size: SizeTypeTokens.XXXL })))));
    };
    const _footerChild = () => {
        return (React.createElement(View, { style: {
                width: '100%',
                padding: 16
            } },
            React.createElement(Button, { type: _isBtnActive
                    ? ButtonTypeTokens.LargeFilled
                    : ButtonTypeTokens.LargeOutline, label: 'Submit for approval', width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, loading: loading, onPress: () => handleSubmitForApproval() }),
            React.createElement(Space, { size: SizeTypeTokens.LG }),
            React.createElement(View, { style: styles.dataSecureFooter },
                React.createElement(Icon, { name: IconTokens.Secure, color: ColorTokens.Secondary_100 }),
                React.createElement(Space, { size: SizeTypeTokens.MD }),
                React.createElement(Typography, { label: 'Your data is secure with us', color: ColorTokens.Secondary_100, fontSize: FontSizeTokens.XXS }))));
    };
    return (React.createElement(View, { style: [
            styles.container,
            { height: Platform.OS === "ios" ? height - 12 : height }
        ] },
        React.createElement(View, { style: {
                flex: 1
            } },
            React.createElement(View, { style: styles.header }, _headerChild()),
            React.createElement(View, { style: [styles.body, { height: height - 192 }] }, _bodyChild()),
            React.createElement(View, { style: styles.footer }, _footerChild()))));
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
const styles = StyleSheet.create({
    container: {
        width: '100%',
    },
    header: {
        ...Platform.OS === "ios" && {
            marginTop: 24
        }
    },
    body: {},
    bodyContainer: {
        height: '100%',
        paddingTop: 16,
        paddingHorizontal: 16,
    },
    bodyTopContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start'
    },
    backContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    backIconContainer: {
        position: 'relative',
        top: 2
    },
    subtitleContainer: {
        paddingHorizontal: 16,
        paddingVertical: 8,
        backgroundColor: '#F1F3F5',
        borderRadius: 8
    },
    dataSecureFooter: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%'
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        zIndex: 99,
        borderWidth: 1,
        borderColor: '#F2F4F7',
        borderTopWidth: 0.5,
        width: "100%",
        alignSelf: 'center',
        shadowOpacity: 0.08,
        elevation: 10,
        // marginHorizontal: -16,
        // marginBottom: -16,
        backgroundColor: 'white',
        shadowOffset: {
            width: 0,
            height: -1,
        },
        shadowRadius: 5,
    },
    groupContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    transactionCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
    },
    transactionTopCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        paddingBottom: 2,
    },
    transactionBottomCardContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: "space-between"
    }
});
export default (SupportingDocumentPage);
